import { connect } from "react-redux"
import { compose } from "redux"
import ProgressReportsThemes from '../components/progress-reports-themes'
import { getVariables } from "../utilities/route"
import { withData } from "../decorators/with-data"
import gql from "graphql-tag"
import { withTranslations } from "../decorators/with-translations"
import { setPrFilters, setSubmitError } from '../actions/survey'
import { toNormalizedRespondentFilters } from '../utilities/helpers'
import { withImprovementProjectData } from './withImprovementProjectData'
import { getPreviousSurveyId } from '../utilities/progress-reports'

const query = gql`
  query ProgressPage(
    $currentSurveyId: UUID!
    $previousSurveyId: UUID!
    $respondentFilters: [RespondentFilterInput!]
    $languageCode: String
  ) {
    currentSurveyStatistics: surveyStatistics(
      surveyId: $currentSurveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        themes { id aggregatedResponse aggregatedImportance }
        drivers { id aggregatedResponse aggregatedImportance }
      }
    }
    previousSurveyStatistics: surveyStatistics(
      surveyId: $previousSurveyId
      respondentFilters: $respondentFilters
      languageCode: $languageCode
    ) {
      __typename
      ... on SurveyStatisticsOutput {
        themes { id aggregatedResponse aggregatedImportance }
        drivers { id aggregatedResponse aggregatedImportance }
      }
    }
  }
`;

const mapStateToProps = ({ survey: { prFilters, prSortingType, sortAscending, submitError } }) => {
  return {
    prFilters,
    prSortingType,
    sortAscending,
    submitError
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSetPrFilters: prFilters => {
      dispatch(setPrFilters(prFilters))
    },
    onSubmitError: (error) => {
      dispatch(setSubmitError(error));
    }
  };
};

export default compose(
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps),
  withData(query, {
    props: ({data}) => ({
      ...data,
      loading: data.loading,
    }),
    options: (props) => {
      const variables = { ...getVariables(props) }

      variables.variables.respondentFilters = toNormalizedRespondentFilters(props.prFilters);

      variables.variables.currentSurveyId = variables.variables.surveyId;
      delete variables.variables.surveyId;
      variables.variables.previousSurveyId = getPreviousSurveyId(
        props.questionnaire.surveySequence,
        variables.variables.currentSurveyId
      );

      return {
        ...variables,
        fetchPolicy: "network-only",
      };
    },
  }),
  withImprovementProjectData,
)(ProgressReportsThemes)



// WEBPACK FOOTER //
// ./src/containers/progress-reports-themes.js